import { render, staticRenderFns } from "./lookhb.vue?vue&type=template&id=32b8891d&scoped=true&"
import script from "./lookhb.vue?vue&type=script&lang=js&"
export * from "./lookhb.vue?vue&type=script&lang=js&"
import style0 from "./lookhb.vue?vue&type=style&index=0&id=32b8891d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b8891d",
  null
  
)

export default component.exports